import $ from "jquery";

/* var gender_filters = $('.horses__filters #gender');

if(gender_filters.length > 0) {
    gender_filters.change(function(){
        var SelectedGender = $(this).children("option:selected").val();
        var horseSingle = $( '.horselist__link' );
        var selectedGenderHorses= $( '.horselist__link[data-gender~=' + SelectedGender + ']' );
        // console.log("Nombre de partenaires - " + selectedPartners.length);

        if ( SelectedGender == 'default' ) {
            horseSingle.removeClass( 'is-hidden' );
			$('.horses__filters-message').addClass('is-hidden'); 
        } else {
			horseSingle.addClass( 'is-hidden' );
			selectedGenderHorses.removeClass( 'is-hidden' );
			// $( '.partner-single[data-territories~=' + selectedTerritory + ']' ).removeClass( 'is-hidden' );
			if(selectedGenderHorses.length < 1) {
				$('.horses__filters-message').removeClass('is-hidden');
			} else {
				$('.horses__filters-message').addClass('is-hidden');
			}
        }
    });
}

var year_filters = $('.horses__filters #year');

if(year_filters.length > 0) {
    year_filters.change(function(){
        var SelectedYear = $(this).children("option:selected").val();
        var horseSingle = $( '.horselist__link' );
        var selectedYearHorses= $( '.horselist__link[data-year~=' + SelectedYear + ']' );
        // console.log("Nombre de partenaires - " + selectedPartners.length);

        if ( SelectedYear == 'default' ) {
            horseSingle.removeClass( 'is-hidden' );
			$('.horses__filters-message').addClass('is-hidden'); 
        } else {
			horseSingle.addClass( 'is-hidden' );
			selectedYearHorses.removeClass( 'is-hidden' );
			// $( '.partner-single[data-territories~=' + selectedTerritory + ']' ).removeClass( 'is-hidden' );
			if(selectedYearHorses.length < 1) {
				$('.horses__filters-message').removeClass('is-hidden');
			} else {
				$('.horses__filters-message').addClass('is-hidden');
			}
        }
    });
} */

